export const dashboard = {
    "dashboard_title": "仪表盘",
    "dashboard_wec": "欢迎回来",
    "dashboard_loading": "加载中...",
    "dashboard_message": "这里能让你快速到达想要的页面",
    "dashboard_class_student_tools": "我的工具",
    "dashboard_class_my_tools": "教师工具",
    "dashboard_class_management_tools": "管理工具",
    "dashboard_class_sp_admin_tools": "超级管理员",
    // 用户工具
    "dashboard_card_submit_hours_title": "提交工时",
    "dashboard_card_submit_hours_desc": "提交并查看你的工时。",
    "dashboard_card_shared_files_title": "共享教学文件",
    "dashboard_card_shared_files_desc": "查看和管理你的教学资料文件。",
    "dashboard_card_available_time_title": "我的可用时间",
    "dashboard_card_available_time_desc": "查看和管理你的可用教学时间。",
    "dashboard_card_my_papers_title": "我的考核试卷",
    "dashboard_card_my_papers_desc": "查看并开始完成你考核的试卷。",
    "dashboard_card_my_class_title": "我的班级",
    "dashboard_card_my_class_desc": "查看班级信息、成员列表及最新动态。",
    "dashboard_card_homeworkBank_title": "作业库",
    "dashboard_card_homeworkBank_desc": "浏览和管理所有已布置的作业与练习。",
    "dashboard_card_my_homework_title": "我的作业",
    "dashboard_card_my_homework_desc": "查看我的作业合集, 未完成的作业",
    "dashboard_card_grade_pending_title": "待批改作业",
    "dashboard_card_grade_pending_desc": "查看并批改学生提交的需人工批改作业。",

    // 管理工具
    "dashboard_card_courses_manager_title": "课程管理",
    "dashboard_card_courses_manager_desc": "查看和管理教师的可用教学时间。",
    "dashboard_card_question_bank_manager_title": "题库管理",
    "dashboard_card_question_bank_manager_desc": "管理教师考核题库。",
    "dashboard_card_paper_manager_title": "考核试卷管理",
    "dashboard_card_paper_manager_desc": "管理教师考核试卷。",
    "dashboard_card_working_manager_title": "工时管理",
    "dashboard_card_working_manager_desc": "工时汇总管理。",
    "dashboard_card_class_manager_title": "班级管理",
    "dashboard_card_class_manager_desc": "管理各个班级和配置班级",

    // 超级管理员
    "dashboard_card_file_log_title": "文件日志",
    "dashboard_card_file_log_desc": "教学文件访问日志。",
    "dashboard_card_sp_admin_manager_title": "超级管理员面板",
    "dashboard_card_sp_admin_manager_desc": "超级管理员页面。"
};
